module.exports = __webpack_public_path__ + "img/pdf-export.e2af16c6.svg";